export const base_url = "https://4k04vnn7zf.execute-api.ap-south-1.amazonaws.com/dev/api/";
export const wss_url = "wss://n2qh581xrh.execute-api.ap-south-1.amazonaws.com/production/";

